import type { CoreFetch } from '~/types/CoreFetch'
import type { Opportunity } from '~/types/Opportunity'

export function provideFetchOpportunityList(coreFetch: CoreFetch) {
  return () => coreFetch.$get<Opportunity[]>('/influencer/opportunities/')
}
